import { Route, Switch, useHistory } from "react-router-dom";
import LoginPage from "@common/pages/LoginPage";
import pbmRoutes from "@pbm/routes";
import ssoRoutes from "@sso/routes";
import refundRoutes from "@refund/routes";
import uploadRoutes from "@upload/routes";
import benefitsRoutes from "@benefits/routes";
import { NotFound } from "@funcional/react-ui";
import { AccessDenied, SsoRole, useJwtUser } from "@funcional/react-auth-ui";

const ROUTES: IRoute[] = [
  {
    path: "/",
    key: "ROOT",
    exact: true,
    component: LoginPage,
  },
  ...pbmRoutes,
  ...ssoRoutes,
  ...refundRoutes,
  ...uploadRoutes,
  ...benefitsRoutes,
];

export interface IMenu {
  label: string;
  roles: SsoRole[];
  path: string;
  routes?: IMenu[];
}

export interface IRouteMenu {
  label: string;
  icon?: JSX.Element;
}

export interface IRoute {
  path: string;
  key: string;
  exact?: boolean;
  component: any;
  routes?: IRoute[];
  menu?: IRouteMenu;
  roles?: SsoRole[];
}

export default ROUTES;

function RouteWithSubRoutes(route: IRoute) {
  const { user } = useJwtUser();
  const history = useHistory();

  if (
    route?.roles !== undefined &&
    !user?.hasAnyOfTheseSsoRoles(...route.roles)
  ) {
    return <AccessDenied goToLastPage={history.goBack} />;
  }
  return (
    <Route
      path={route.path}
      exact={route.exact}
      strict
      render={(props: any) => (
        <route.component {...props} routes={route.routes} />
      )}
    />
  );
}

export function RenderRoutes({ routes }: { routes: IRoute[] }) {
  const history = useHistory();

  return (
    <Switch>
      {routes.map((route, i) => {
        return <RouteWithSubRoutes {...route} />;
      })}
      <Route component={() => <NotFound goToLastPage={history.goBack} />} />
    </Switch>
  );
}
